 // collection page in default silver color selected
document.addEventListener("DOMContentLoaded", function() {
    // Check if the body element contains the class 'silver-collection'
    if (document.body.classList.contains('silver-collection')) {
        var filterSection = document.querySelector('.facets-sidebar');
        if (filterSection) {
            var silverColorCheckbox = filterSection.querySelector('input[type="checkbox"][value="Silver Color"]');
            // If the checkbox is found and is not already checked, click it to select it
            if (silverColorCheckbox && !silverColorCheckbox.checked) {
                silverColorCheckbox.click();
            }
        }
    }
});


$(document).ready(function () {


//   // Assuming you fetch the base price in Euros
// let basePriceInEuros = 250;

// // Check if Shopify.currency object exists
// if (typeof Shopify !== 'undefined' && Shopify.currency) {
//     let activeCurrency = Shopify.currency.active; // e.g., 'USD'
//     let exchangeRate = Shopify.currency.rate; // e.g., 1.1 for Euro to USD

//     // Convert to active currency
//     let convertedPrice = basePriceInEuros * exchangeRate;

//     console.log(`Price in ${activeCurrency}: ${convertedPrice.toFixed(2)}`);
// }
  
//Ak custom code
  // js/common/utilities/format-money.js
function formatMoney(cents, format = "") {
  if (typeof cents === "string") {
    cents = cents.replace(".", "");
  }
  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/, formatString = format || window.themeVariables.settings.moneyFormat;
  function defaultTo(value2, defaultValue) {
    return value2 == null || value2 !== value2 ? defaultValue : value2;
  }
  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultTo(precision, 2);
    thousands = defaultTo(thousands, ",");
    decimal = defaultTo(decimal, ".");
    if (isNaN(number) || number == null) {
      return 0;
    }
    number = (number / 100).toFixed(precision);
    let parts = number.split("."), dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands), centsAmount = parts[1] ? decimal + parts[1] : "";
    return dollarsAmount + centsAmount;
  }
  let value = "";
  switch (formatString.match(placeholderRegex)[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2);
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0);
      break;
    case "amount_with_space_separator":
      value = formatWithDelimiters(cents, 2, " ", ".");
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;
    case "amount_with_apostrophe_separator":
      value = formatWithDelimiters(cents, 2, "'", ".");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ".", ",");
      break;
    case "amount_no_decimals_with_space_separator":
      value = formatWithDelimiters(cents, 0, " ");
      break;
    case "amount_no_decimals_with_apostrophe_separator":
      value = formatWithDelimiters(cents, 0, "'");
      break;
    default:
      value = formatWithDelimiters(cents, 2);
      break;
  }
  if (formatString.indexOf("with_comma_separator") !== -1) {
    return formatString.replace(placeholderRegex, value);
  } else {
    return formatString.replace(placeholderRegex, value);
  }
}

  
  function shipping_text() {
  fetch('/cart.js')
    .then((response) => response.json())
    .then((cart) => {

      // skip advent-calendar
          const filteredItems = cart.items.filter(
          item => item.id !== 53240668291404 && item.handle !== '12-days-jewelry-advent-calendar'
          );
          const hasAdventCalendar = cart.items.length !== filteredItems.length;
          if (hasAdventCalendar) {
          console.log("Advent Calendar found — excluded from progress calculation");
          }
          const adjustedTotal = filteredItems.reduce((sum, item) => sum + item.original_line_price, 0);
          // console.log("Adjusted cart total (without Advent Calendar):", adjustedTotal);
          // end skip advent-calendar


      const currencyFormat = window.themeVariables.settings.currencyCodeEnabled
        ? window.themeVariables.settings.moneyWithCurrencyFormat
        : window.themeVariables.settings.moneyFormat;

      // const cartTotal = cart.total_price;
      const cartTotal = adjustedTotal;
      // const cartTotal = cart.original_total_price ;
      const currency = Shopify?.currency?.active || 'USD';
      const rate = (Shopify?.currency?.rate || 1) * 100;

      // Collect and filter gifts from <body> data attributes
      const rawGifts = [
         {
          price: parseFloat(document.body.getAttribute('data-free-gift-price')),
          isDefault: document.body.getAttribute('data-free-gift-default') === 'true',
          title: document.body.getAttribute('data-free-product-title'),
          variantId: parseInt(document.body.getAttribute('data-free-pro')),
          freeText: document.body.getAttribute('data-free-text'),
        },
        {
          price: parseFloat(document.body.getAttribute('data-second-free-gift-price')),
          isDefault: document.body.getAttribute('data-second-free-gift-default') === 'true',
          title: document.body.getAttribute('data-second-free-product-title'),
          variantId: parseInt(document.body.getAttribute('data-second-free-pro')),
          freeText: document.body.getAttribute('data-second-free-text'),
        },
        {
          price: parseFloat(document.body.getAttribute('data-third-free-gift-price')),
          isDefault: document.body.getAttribute('data-third-free-gift-default') === 'true',
          title: document.body.getAttribute('data-third-free-product-title'),
          variantId: parseInt(document.body.getAttribute('data-third-free-pro')),
          freeText: document.body.getAttribute('data-third-free-text'),
        },
        {
          price: parseFloat(document.body.getAttribute('data-four-free-gift-price')),
          isDefault: document.body.getAttribute('data-third-free-gift-default') === 'true',
          title: document.body.getAttribute('data-third-free-product-title'),
          variantId: parseInt(document.body.getAttribute('data-third-free-pro')),
          freeText: document.body.getAttribute('data-four-free-text'),
        },
      ];



      const gifts = rawGifts
       .filter(g => (g.price > 0 && g.variantId > 0) || g.freeText)
        .map(g => ({
          ...g,
          convertedPrice: g.isDefault ? g.price * rate : g.price * 100,
          freeText: g.freeText 
        }))
        .sort((a, b) => a.convertedPrice - b.convertedPrice);

        console.log("gifts.length:--",gifts.length);
      if (gifts.length === 0) return;

      let activeGiftIndex = -1;
      let nextGift = null;

      for (let i = gifts.length - 1; i >= 0; i--) {
        if (cartTotal >= gifts[i].convertedPrice) {
          activeGiftIndex = i;
          break;
        }
      }

      if (activeGiftIndex < gifts.length - 1) {
        nextGift = gifts[activeGiftIndex + 1];
      }

      // console.log("freeText:--",gifts[1].freeText);
      // console.log("freeText:--",gifts[2].freeText);
      // console.log("freeText:--",gifts[3].freeText);
      

      // fallback handling for single gift
        let shippingHTML = '';

        if (nextGift) {
          const remainingAmount = nextGift.convertedPrice - cartTotal;
          const formatted = formatMoney(remainingAmount, currencyFormat);
          const giftLabel = nextGift.freeText && nextGift.freeText.trim() !== ""
            ? nextGift.freeText
            : nextGift.title;
          shippingHTML = `You're <strong>${formatted}</strong> away from ${giftLabel}!`;
        } else if (gifts.length === 1) {
          //  handle when only 1 gift threshold exists
          const remainingAmount = gifts[0].convertedPrice - cartTotal;
          if (remainingAmount > 0) {
            const formatted = formatMoney(remainingAmount, currencyFormat);
            const giftLabel = gifts[0].freeText && gifts[0].freeText.trim() !== ""
              ? gifts[0].freeText
              : gifts[0].title;
            shippingHTML = `You're <strong>${formatted}</strong> away from ${giftLabel}!`;
          } else {
            shippingHTML = `Congratulations, enjoy your ${gifts[0].title}!`;
          }
        } else {
          shippingHTML = `Congratulations, and enjoy free shipping! 🎉`;
        }

        $('#cart-drawer .cart-progress-main .cart_progress_heading').html(shippingHTML);

      // Progress bar logic
      let progressPercentage = 0;
        const totalTiers = $('.upcart-rewards-tier').length;
        console.log('Total gift tiers:', totalTiers);

        if (totalTiers >= 3) {
          if (cartTotal < gifts[0].convertedPrice) {
            progressPercentage = (cartTotal / gifts[0].convertedPrice) * 25;
          } else if (gifts[1] && cartTotal < gifts[1].convertedPrice) {
            const range = gifts[1].convertedPrice - gifts[0].convertedPrice;
            const progressInRange = cartTotal - gifts[0].convertedPrice;
            progressPercentage = 25 + (progressInRange / range) * 25;
          } else if (gifts[2] && cartTotal < gifts[2].convertedPrice) {
            const range = gifts[2].convertedPrice - gifts[1].convertedPrice;
            const progressInRange = cartTotal - gifts[1].convertedPrice;
            progressPercentage = 50 + (progressInRange / range) * 25;
          } else if (gifts[3] && cartTotal < gifts[3].convertedPrice) {
            const range = gifts[3].convertedPrice - gifts[2].convertedPrice;
            const progressInRange = cartTotal - gifts[2].convertedPrice;
            progressPercentage = 75 + (progressInRange / range) * 25;
          } else {
            progressPercentage = 100;
          }
        }

        else if (totalTiers === 2) {
          if (cartTotal < gifts[0].convertedPrice) {
            progressPercentage = (cartTotal / gifts[0].convertedPrice) * 50;
          } else if (gifts[1] && cartTotal < gifts[1].convertedPrice) {
            const range = gifts[1].convertedPrice - gifts[0].convertedPrice;
            const progressInRange = cartTotal - gifts[0].convertedPrice;
            progressPercentage = 50 + (progressInRange / range) * 50;
          } else {
            progressPercentage = 100;
          }
        }

        else if (totalTiers === 1) {
          if (cartTotal < gifts[0].convertedPrice) {
            progressPercentage = (cartTotal / gifts[0].convertedPrice) * 100;
          } else {
            progressPercentage = 100;
          }
        }

        else {
          progressPercentage = 0;
        }

        console.log("Progress %:", progressPercentage);


      fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {

        const filteredItems = cart.items.filter(
          item => item.id !== 53240668291404 && item.handle !== '12-days-jewelry-advent-calendar'
        );

        const hasAdventCalendar = cart.items.length !== filteredItems.length;
        if (hasAdventCalendar) {
          // console.log("Advent Calendar found — excluded from progress calculation");
        }

        const adjustedTotal = filteredItems.reduce((sum, item) => sum + item.original_line_price, 0);
        const cartTotal_new = adjustedTotal / 100;
        // console.log("Adjusted cart total (without Advent Calendar):", cartTotal_new);

        const tiers = document.querySelectorAll('.main-step-item');

        tiers.forEach((tier, index) => {
          const tierPrice = parseFloat(tier.dataset.price);
          console.log(`tierPrice (${index}):`, tierPrice);

          if (cartTotal_new >= tierPrice) {
            tier.classList.add('active');
          } else {
            tier.classList.remove('active');
          }
        });

        // (Optional) — you can also update progress bars or labels here

      })
      .catch(error => console.error('Error fetching cart:', error));

      
      document.querySelector('.cart-progress .progress').style.width = `${progressPercentage}%`;

      // Add/remove gifts
      const updates = {};
      let needUpdate = false;

      gifts.forEach((gift, index) => {
          const isInCart = cart.items.some(item => item.id === gift.variantId);

          if (gift.variantId && index <= activeGiftIndex && !isInCart) {
            // add gift only if missing
            fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ items: [{ id: gift.variantId, quantity: 1 }] }),
            })
              .then(res => res.json())
              .then(data => {
                document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: data }));
              })
              .catch(error => console.error(`Error adding gift ${index + 1}:`, error));
          } else if (gift.variantId && index > activeGiftIndex && isInCart) {
            const productToRemove = cart.items.find(item => item.id === gift.variantId);
            if (productToRemove) {
              updates[productToRemove.id] = 0;
              needUpdate = true;
            }
          }
        });

      if (needUpdate) {
        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates }),
        })
          .then(res => res.json())
          .then(data => {
            document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: data }));
          })
          .catch(error => console.error('Error removing gifts:', error));
      }
    })
    .catch((error) => {
      console.error('Error fetching cart:', error);
    });
}

// Only call function if any variant ID is set
const giftPro = parseInt(document.body.getAttribute('data-free-pro'));
const giftPro2 = parseInt(document.body.getAttribute('data-second-free-pro'));
const giftPro3 = parseInt(document.body.getAttribute('data-third-free-pro'));
const giftPro4 = parseInt(document.body.getAttribute('data-third-free-pro'));

const giftPro_text = document.body.getAttribute('data-free-text');
const giftPro2_text = document.body.getAttribute('data-second-free-text');
const giftPro3_text = document.body.getAttribute('data-third-free-text');
const giftPro4_text = document.body.getAttribute('data-four-free-text');

if ((giftPro && giftPro > 0) || (giftPro2 && giftPro2 > 0) || (giftPro3 && giftPro3 > 0) || (giftPro4 && giftPro4 > 0) || (giftPro_text) || (giftPro2_text) || (giftPro3_text) || (giftPro4_text)) {
  shipping_text();
}


  function fetchRecommendationProducts(){
     fetch('/cart.js')
    .then((response) => response.json())
    .then((cart) => {
      var currencyFormat = window.themeVariables.settings.currencyCodeEnabled 
        ? window.themeVariables.settings.moneyWithCurrencyFormat 
        : window.themeVariables.settings.moneyFormat;
      
        var items = cart.items;
  
        if(items){
          var item_length = '';
          for(var i=0; i < items.length; i++){
            if(items.length){
              var item_length = items.length - 1;
            }
          }
     
          console.log(items[item_length].product_id);

          fetch(window.Shopify.routes.root + "recommendations/products.json?product_id=" + items[item_length].product_id + "&limit=8&intent=related")
            .then(response => response.json())
            .then(({ products }) => {
              
              if (products && products.length > 0) {
                $('.cart-product-recommendations_main').show();
                $('.cart-product-recommendations .cart_recommend_main').empty(); // Clear existing products

                var htmlthis = '';
                
                for(var i=0; i < products.length; i++){
                  // console.log(products[i].variants[0])
                  htmlthis += '<div class="swiper-slide ajaxcart__product upcell-product" data-upcell-product="'+products[i].variants[0].id+'" data-pro-id="'+products[i].id+'">';
                  htmlthis += '<div class="ajaxcart row" data-line="1">';
                  htmlthis += '<div class="grid__item one-quarter no-padding">';
                  if(products[i].variants[0].featured_image){
                    htmlthis += '<a href="'+products[i].url+'" class="ajaxcart__product-image"><img src="'+products[i].variants[0].featured_image.src+'" alt="'+products[i].title+'"></a>';
                  }else{
                    htmlthis += '<a href="'+products[i].url+'" class="ajaxcart__product-image"><img src="'+products[i].featured_image+'" alt="'+products[i].title+'"></a>';
                  }
                  htmlthis += '</div>';
                  
                  htmlthis += '<div class="grid__item three-quarters ajaxcart-right">';
                  htmlthis += '<div class="ajax-rtinner-right-top">';
                  htmlthis += '<a href="'+products[i].url+'" class="ajaxcart__product-name">'+ products[i].title +'</a>';
                  htmlthis += '<span class="product-price-div">';
                  if(products[i].variants[0].compare_at_price > products[i].variants[0].price){
                    htmlthis += '<span class="comp_price" data-variant-id="'+products[i].variants[0].id+'">'+formatMoney(products[i].variants[0].compare_at_price, currencyFormat)+'</span><span class="ori_price" data-variant-id="'+products[i].variants[0].id+'">'+formatMoney(products[i].variants[0].price, currencyFormat)+'</span>';
                  }else{
                    htmlthis += '<span class="comp_price hidden" data-variant-id="'+products[i].variants[0].id+'">'+formatMoney(products[i].variants[0].compare_at_price, currencyFormat)+'</span><span class="ori_price" data-variant-id="'+products[i].variants[0].id+'">'+formatMoney(products[i].variants[0].price, currencyFormat)+'</span>';
                  }
                  htmlthis += '</span>';
                  htmlthis += '</div>';
                  
                  htmlthis += '<div class="add-to-cart-overlay">';
                  
                  // if(products[i].variants.length > 1){
                  // htmlthis += '<button class="cart-btn add-to-cart-image-modal" data-id="'+products[i].variants[0].id+'">';
                  // htmlthis += '<font class="cart_btn_text">Add</font>';
                  // htmlthis += '</button>';
                  // }
                  // else{
                  // htmlthis += '<button class="cart-btn add-to-cart-btn" id="AddToCart" data-id="'+products[i].variants[0].id+'">';
                  // htmlthis += '<font class="cart_btn_text">Add</font>';
                  // htmlthis += '</button>';
                  // }
                  
                  if(products[i].variants.length > 1){
                  htmlthis += '<div class="overlay-product-options">';
                  htmlthis += '<select class="var-select product-var-'+products[i].id+'">';
                      for(var j=0;j < products[i].variants.length; j++){
                        if(products[i].variants[j].available){
                          if(products[i].variants[j].compare_at_price > products[i].variants[j].price){
                            if(products[i].variants[j].featured_image){
                              htmlthis += '<option value="'+products[i].variants[j].id+'" data-img-src="'+products[i].variants[j].featured_image.src+'" data-price="'+products[i].variants[j].price+'" data-comp-price="'+products[i].variants[j].compare_at_price+'">'+products[i].variants[j].title+'</option>';
                            }else{
                              htmlthis += '<option value="'+products[i].variants[j].id+'" data-img-src="'+products[i].featured_image+'" data-price="'+products[i].variants[j].price+'" data-comp-price="'+products[i].variants[j].compare_at_price+'">'+products[i].variants[j].title+'</option>';
                            }
                          }else{
                            if(products[i].variants[j].featured_image){
                              htmlthis += '<option value="'+products[i].variants[j].id+'" data-img-src="'+products[i].variants[j].featured_image.src+'" data-price="'+products[i].variants[j].price+'">'+products[i].variants[j].title+'</option>';
                            }else{
                              htmlthis += '<option value="'+products[i].variants[j].id+'" data-img-src="'+products[i].featured_image+'" data-price="'+products[i].variants[j].price+'" data-comp-price="'+products[i].variants[j].compare_at_price+'">'+products[i].variants[j].title+'</option>';
                            }
                            
                          }
                        }else{
                          if(products[i].variants[j].featured_image){
                            htmlthis += '<option value="'+products[i].variants[j].id+'" disabled data-img-src="'+products[i].variants[j].featured_image.src+'" data-price="'+products[i].variants[j].price+'">'+products[i].variants[j].title+'</option>';
                          }else{
                              htmlthis += '<option value="'+products[i].variants[j].id+'" disabled data-img-src="'+products[i].featured_image+'" data-price="'+products[i].variants[j].price+'">'+products[i].variants[j].title+'</option>';
                          }
                          
                        }
                      }
                  htmlthis += '</select>';
                  // htmlthis += '<ul class="product-'+products[i].id+'">';
                   
                  //   for(var j=0;j < products[i].variants.length; j++){
                  //     if(products[i].variants[j].available){
                  //       htmlthis += '<li value="'+products[i].variants[j].id+'">'+formatMoney(products[i].variants[j].price, currencyFormat)+'<span class="compare-wrap">'+formatMoney(products[i].variants[j].compare_at_price, currencyFormat)+'</span> -'+products[i].variants[j].title;
                  //       htmlthis += '</li>';
                  //     }
                  //     else{
                  //       htmlthis += '<li value="'+products[i].variants[j].id+'" class="trigger_bis" data-p-handle="'+products[i].handle+'">'+formatMoney(products[i].variants[j].price, currencyFormat)+'<span class="compare-wrap">'+formatMoney(products[i].variants[j].compare_at_price, currencyFormat)+'</span> (SOLD OUT) -'+products[i].variants[j].title;
                  //       htmlthis += '</li>';
                  //     }
                  //   }
                  // htmlthis += '</ul>';
                  htmlthis += '</div>';
                  }

                  htmlthis += '<button class="cart-btn add-to-cart-btn" id="AddToCart" data-id="'+products[i].variants[0].id+'">';
                  htmlthis += '<font class="cart_btn_text">Add</font>';
                  htmlthis += '</button>';
                  
                  htmlthis += '</div>';
                  
                  // htmlthis += '<div class="product-price-div">'+formatMoney(products[i].variants[0].price, currencyFormat)+'</div>';
                  
                  htmlthis += '</div>';
                  
                  htmlthis += '</div>';
                  htmlthis += '</div>';
                }

                $('.cart-product-recommendations .cart_recommend_main').html(htmlthis);

                // Initialize Swiper
                new Swiper('.cart-product-recommendations', {
                  slidesPerView: 1, // Adjust based on your layout
                  spaceBetween: 10, // Adjust as needed
                  navigation: {
                    nextEl: '.swiper-button-next-cart',
                    prevEl: '.swiper-button-prev-cart',
                  },
                  pagination: {
                    el: '.swiper-pagination-cart',
                    clickable: true,
                  },
                  loop: true,
                });

              // Add event listener for dropdown changes
              $('.cart-product-recommendations').on('change', 'select.var-select', function () {
                const $select = $(this);
                const $parent = $select.closest('.swiper-slide');
                const selectedOption = $select.find('option:selected');
              
                // Get data from the selected option
                const variantId = selectedOption.val();
                const variantImage = selectedOption.data('img-src');
                const variantPrice_no_m = selectedOption.data('price');
                const variantComparePrice_no_m = selectedOption.data('comp-price');
                const variantPrice = formatMoney(variantPrice_no_m, currencyFormat);
                const variantComparePrice = formatMoney(variantComparePrice_no_m, currencyFormat);
                            
                $parent.find('.add-to-cart-btn').attr('data-id', variantId);          
                $parent.find('.ajaxcart__product-image img').attr('src', variantImage);
                const $priceDiv = $parent.find('.product-price-div');

                
                if (variantComparePrice_no_m) {
                  $priceDiv.html(
                    `<span class="comp_price" data-variant-id="${variantId}">${variantComparePrice}</span>
                     <span class="ori_price" data-variant-id="${variantId}">${variantPrice}</span>`
                  );
                } else {
                  $priceDiv.html(
                    `<span class="comp_price hidden" data-variant-id="${variantId}">${variantComparePrice}</span>
                     <span class="ori_price" data-variant-id="${variantId}">${variantPrice}</span>`
                  );
                }
              });

              // Event listener for Add to Cart button clicks
              $('.cart-product-recommendations').on('click', '.add-to-cart-btn', function (e) {
                e.preventDefault();
                const $button = $(this);
                const variantId = $button.attr('data-id');
                if (!variantId) {
                  return;
                }
                // Add the product to the cart using Shopify's AJAX API
                $.ajax({
                    type: 'POST',
                    url: '/cart/add.js',
                    data: {
                      id: variantId,
                      quantity: 1,
                    },
                    dataType: 'json',
                    success: function (response) {
                      document.dispatchEvent(new CustomEvent('cart:build' , {bubbles: true})); 
                      document.dispatchEvent(new CustomEvent('cart:refresh', {
                        bubbles: true
                      }));
                    },
                    error: function (xhr, status, error) {
                      console.error('Error adding product to cart:', error);
                    },
                  });
                });
      
              }else{
                $('.cart-product-recommendations_main').hide();
              }
            })     
            .catch(error => {
                console.error('Error fetching recommendation products:', error);
            });
            
        }
    })
    .catch((error) => {
      console.error('Error fetching cart:', error);
    });
  }
  fetchRecommendationProducts();
//End Ak custom code

  
  $(document).on('click','.product-info .BenefitItem',function(){
    $(document).find('.PageOverlay.is-visible').addClass('is-product-benefit');
    $(document).find('.PageOverlay.is-visible').css('display','block !important');
  });
  $(document).on('click','.product-info .BenefitBadge',function(){
    $(document).find('.PageOverlay.is-visible').addClass('is-product-benefit');
    $(document).find('.PageOverlay.is-visible').css('display','block !important');
  });

  $(".header .header__secondary-nav .Header__CurrencySelector").insertBefore(".header .header__logo");

  //review home page swiper
  var swiper = new Swiper(".mySwiper-review", {
    slidesPerView: 1.3,
    spaceBetween: 20,
    centeredSlides: true,
    loop: false,
    pagination: {
      el: ".swiper-pagination-review",
      clickable: true,
    },
    navigation: {
      nextEl: ".swiper-button-next-review",
      prevEl: ".swiper-button-prev-review",
    },
    breakpoints: {
      768: {
        slidesPerView: 3,
        spaceBetween: 20,
        centeredSlides: false,
      },
      1024: {
        slidesPerView: 4,
        spaceBetween: 20,
        centeredSlides: false,
      }
    }
  });
  $('.header-sidebar__nested_open_close').click(function(){
    $(this).parent().toggleClass("active");
  });

  //announcement swiper
  if(document.body.clientWidth <= 768 && document.querySelector("[data-announcement-slider]")){
    var swiper = new Swiper("[data-announcement-slider]", {
      slidesPerView: 1,
      loop: true,
      navigation: {
       nextEl: ".swiper-button-next-announce",
       prevEl: ".swiper-button-prev-announce",
      }
    });
    $(".shopify-section--announcement-bar").insertAfter(".shopify-section--header");
  }
    
  //header
  $(document).on('change','select.CurrencySelector__Select',function(){
    var url = window.location.href;
    var value = $(this).val();
      if(url.includes('/?')){
        window.location.href = url + '&currency=' + value;
      }else{
        window.location.href = url + '?currency=' + value;
      }
  });

  //footer
  $('body').find('.currency_selector_flag .slected_currency').on('click', function(){
    $("ul.all_currency").toggle();
  });

  $('body').find('.currency_selector_flag ul.all_currency li').each(function(){
    $(this).on('click', function(){
      var value = $(this).attr('value');
      var image_src = $(this).find('img').attr('src');
      // alert(value);
      // alert(image_src);
      $('body').find('.currency_selector_flag .slected_currency img').attr('src',image_src);
      $('body').find('.currency_selector_flag .slected_currency span').html(value);
      $("ul.all_currency").toggle();
      
      var currentUrl = new URL(window.location.href);
      currentUrl.searchParams.set('currency',value);
      window.location.href = currentUrl.href;
    });
  });

  //product-card on image-swiper  
  if(window.location.pathname.includes("/collections/")){
     if(document.body.clientWidth <= 768 && document.querySelector(".mySwiper-productCard")){
      var swiper = new Swiper(".mySwiper-productCard", {
        spaceBetween: 30,
        speed: 1000,
        pagination: {
          el: ".swiper-pagination-productCard",
          clickable: true,
        },
         breakpoints: {
        768: {
          slidesPerView: 3,
          spaceBetween: 20,
          speed: 1000,
          centeredSlides: false,
        },
        1024: {
          slidesPerView: 4,
          spaceBetween: 20,
          speed: 1000,
          centeredSlides: false,
        }
      },
      });
    }
  }
  
 //rendom number on product page
  var timeElement = document.querySelector("#rendom_no");
  if(timeElement){
    
    function getCookiePath(randomnumber) {
      const cookies = document.cookie.split('; ');
      for (let i = 0; i < cookies.length; i++) {
          const cookie = cookies[i].split('=');
          if (cookie[0] == 'randomnumber') {
              return cookie[1]; 
          }
      }
    }
    const getCookiesInt =parseInt(getCookiePath());
    const element = document.getElementById("rendom_no"); 
    const newRandomNumber = element.getAttribute("attr"); 
    const newRandomNumberInt = parseInt(newRandomNumber);
    
    function setRandomNumberCookie(randomnumber) {
      if ( isNaN(getCookiesInt) || getCookiesInt  < newRandomNumberInt && window.location.pathname.includes("/products/") ) {
        //randomnumber liquid code
        document.getElementById("rendom_no").innerHTML = newRandomNumber;
        //cookies 
        let date = new Date();
        date.setTime(date.getTime() + (24 * 60 * 60 * 1000)); 
        const expires = "expires=" + date.toUTCString();
        let path = "/";
        path = window.location.pathname;      
        let cookies = document.cookie = randomnumber + "=" + newRandomNumber + "; " + expires + ";" + "path" + "=" + path;
      }else{
          document.getElementById("rendom_no").innerHTML = getCookiesInt;
      }   
    }
     setRandomNumberCookie('randomnumber');
    
  }

  var swiper = new Swiper(".product_image_swiper_slider", {
    slidesPerView: 1.4,
    spaceBetween: 24,
    centeredSlides: false,
    loop: false,
    navigation: {
      nextEl: ".image_swiper_arrows .swiper-button-next",
      prevEl: ".image_swiper_arrows .swiper-button-prev",
    },
    breakpoints: {
      800: {
        slidesPerView: 5,
        spaceBetween: 24,
        centeredSlides: false,
      },
      480: {
        slidesPerView: 2.8,
        spaceBetween: 24,
      },
    }
  });
});
// document ready -- end

//paoduct page image-swiper  

document.addEventListener('submit', async function (event) {
  const form = event.target;
  if (!form.matches('.cart-drawer__footer')) {
    return;
  }

  const submitter = event.submitter;
  if (!submitter || submitter.name !== 'checkout') {
    return;
  }

  event.preventDefault();

  if (form.dataset.checkoutValidating === 'true') {
    return;
  }

  form.dataset.checkoutValidating = 'true';
  const checkoutButton = submitter;

  try {
    checkoutButton.disabled = true;

    const cartResponse = await fetch('/cart.js', {
      credentials: 'same-origin'
    });

    const cart = await cartResponse.json();
    const giftVariantIds = [
      parseInt(document.body.getAttribute('data-free-pro')),
      parseInt(document.body.getAttribute('data-second-free-pro')),
      parseInt(document.body.getAttribute('data-third-free-pro')),
      parseInt(document.body.getAttribute('data-fourth-free-pro'))
    ].filter(id => id > 0);

    if (!giftVariantIds.length) {
      window.location.href = '/checkout';
      return;
    }

    const giftItems = cart.items.filter(item =>
      giftVariantIds.includes(Number(item.variant_id))
    );

    if (!giftItems.length) {
      window.location.href = '/checkout';
      return;
    }

    const nonGiftItems = cart.items.filter(item =>
      !giftVariantIds.includes(Number(item.variant_id))
    );

    const filteredItems = nonGiftItems.filter(item =>
      item.id !== 53240668291404 &&
      item.handle !== '12-days-jewelry-advent-calendar'
    );

    const qualifyingTotal = filteredItems.reduce(
      (total, item) => total + item.original_line_price,
      0
    );

    const giftData = [
      {
        variantId: parseInt(document.body.getAttribute('data-free-pro')),
        price: parseFloat(document.body.getAttribute('data-free-gift-price')),
        isDefault: document.body.getAttribute('data-free-gift-default') === 'true'
      },
      {
        variantId: parseInt(document.body.getAttribute('data-second-free-pro')),
        price: parseFloat(document.body.getAttribute('data-second-free-gift-price')),
        isDefault: document.body.getAttribute('data-second-free-gift-default') === 'true'
      },
      {
        variantId: parseInt(document.body.getAttribute('data-third-free-pro')),
        price: parseFloat(document.body.getAttribute('data-third-free-gift-price')),
        isDefault: document.body.getAttribute('data-third-free-gift-default') === 'true'
      },
      {
        variantId: parseInt(document.body.getAttribute('data-four-free-pro')),
        price: parseFloat(document.body.getAttribute('data-four-free-gift-price')),
        isDefault: document.body.getAttribute('data-four-free-gift-default') === 'true'
      }
    ].filter(gift =>
      gift.variantId > 0 &&
      gift.price > 0
    );

    const rate = (Shopify?.currency?.rate || 1) * 100;
    const gifts = giftData
      .map(gift => ({
        ...gift,
        convertedPrice: gift.isDefault
          ? gift.price * rate
          : gift.price * 100
      }))
      .sort((a, b) => a.convertedPrice - b.convertedPrice);

    let activeGiftIndex = -1;
    for (let i = gifts.length - 1; i >= 0; i--) {
      if (qualifyingTotal >= gifts[i].convertedPrice) {
        activeGiftIndex = i;
        break;
      }
    }

    const updates = {};
    giftItems.forEach(item => {
      const giftIndex = gifts.findIndex(
        gift => Number(gift.variantId) === Number(item.variant_id)
      );

      if (giftIndex > activeGiftIndex) {
        updates[item.key] = 0;
      }
    });

    if (Object.keys(updates).length) {
      await fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        credentials: 'same-origin',
        body: JSON.stringify({
          updates
        })
      });

      document.dispatchEvent(
        new CustomEvent('cart:refresh', {
          bubbles: true
        })
      );

      form.dataset.checkoutValidating = 'false';
      checkoutButton.disabled = false;

      return;
    }

    if (nonGiftItems.length === 0) {
      form.dataset.checkoutValidating = 'false';
      checkoutButton.disabled = false;

      const removeOnlyGiftUpdates = {};

      giftItems.forEach(item => {
        removeOnlyGiftUpdates[item.key] = 0;
      });

      if (Object.keys(removeOnlyGiftUpdates).length) {
        await fetch('/cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          credentials: 'same-origin',
          body: JSON.stringify({
            updates: removeOnlyGiftUpdates
          })
        });

        document.dispatchEvent(
          new CustomEvent('cart:refresh', {
            bubbles: true
          })
        );
      }

      return;
    }

    window.location.href = '/checkout';
  } catch (error) {
    console.error('Checkout validation error:', error);
    form.dataset.checkoutValidating = 'false';
    checkoutButton.disabled = false;
    window.location.href = '/checkout';
  }
});